import React, { useState, useEffect } from "react";
import "../styles/mercclienthub.css";
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import TrustPilot from "../components/TrustPilot";
import QuestionFormatFaq from "../components/QuestionFormatFaq";	
import Footer from "../components/Footer";
import { initializeTalkdesk } from '../helpers/talkdeskHelper';			
import { NavBar } from "../components/NavBar";		
import { initializeEmailButton } from '../helpers/emailButtonHelper';


function MercClientHub() {
	
	const [data, setData] = useState({ questions: [] });

	const questions = {
		"faqHeading": "Frequently asked questions",
		"faqs": [
		  {
			"id": 1,
			"label": "How much could I receive?",
			"value": "The amount that could be won is dependent on a number of factors.\n\nAs each case progresses, we will be able to give a more accurate depiction of this figure, so be sure to check your emails after signing up to My Diesel Claim for updates."},
		  { "id": 2, "label": "How much will I be charged?", "value": "Your My Diesel Claim is being litigated on a No-Win, No-Fee basis, meaning it costs you nothing to join. If we do not win you compensation, we will cover all legal costs and you will not pay a penny.\n\nIf the case is won, a percentage will be deducted from your compensation costs to cover legal fees, court fees, and our success fee. Unlike some other firms, we cap our fees at a maximum of 50% inclusive of VAT, although the actual fee may be as low as 20%.\n\nIf you purchased or leased your vehicle in Scotland, your claim will be dealt with by our Scottish team. Scottish claims are also pursued on a ‘No-Win, No-Fee basis’, but different fee terms apply.\n\nType in your vehicles model at the top of this page for more information and to start your claim in under a minute.\n\nFor peace of mind, feel free to head to the Money Saving Expert website where a comparison of all the firms litigating the claim and their costs are laid out." },
		  { "id": 3, "label": "Why should I choose Pogust Goodhead?", "value": "Pogust Goodhead is paving the way for emissions claims in the UK, and our team of legal professionals are unrivalled in group litigation claims. We were integral in the £193M settlement with VW, and we are continuing to fight for justice for all UK drivers. We already have more drivers signed up than all other UK firms combined, meaning more people have put their trust in us to handle their claims. You can read more about the diesel emissions claim on the Money Saving Expert website." },
		  {"id": 4, "label": "Have any UK drivers received compensation payments?", "value": "Yes. In May 2022, Volkswagen agreed to a £193million payment for around 91,000 drivers in an out of court UK settlement.\n\nThe settlement was a part of our VW1 claim for cars with EA189 engines, which were first registered between 2008 and 2015. Whilst this settlement is the first of its kind in the UK, we are confident it will not be the last.\n\nWe are still pursuing claims against the Volkswagen Group for vehicles registered from 2009 – 2020 and you can sign up now."},
		  {"id": 5, "label":"Why is it important to claim?", "value":"We believe customers have been deliberately misled about the amount of emissions their vehicles were producing, and think customers should be compensated for the following reasons:\n\nThe increased Nitrogen Dioxide levels are harmful to children, adults, and the environment\n\nCustomers may have experienced higher fuel bills and maintenance costs\n\nThe performance of these vehicles was negatively affected.\n\nYou can help the environment while making money by claiming back from your vehicle manufacturer. Input your vehicle model at the top of this page and start your claim in under a minute.  "},
		  {"id":8, "label":"Which brands are involved?", "value":"Since Volkswagen were investigated in 2015, a number of car manufacturers have joined the scandal and have been investigated for diesel emissions fraud.\n\nThe brands include, but are not limited to:\n\nMercedes\n\nVauxhall\n\nFiat\n\nChrysler\n\nJeep\n\nRenault\n\nNissan\n\nAlfa Romeo\n\nSuzuki\n\nMany more\n\nPogust Goodhead are litigating against more manufacturers than any other UK law firm. You can read more on this on the Money Saving Expert website."},
		  {"id":10, "label":"Can I claim for more than one vehicle?", "value":"Yes. You are entitled to sign up for every diesel vehicle you owned, or still own, within the time period.\n\nPlease be aware that, if you sign up with multiple vehicles, then you may receive multiple communications and requests for information. All emails will contain matter reference and VRN, so please check each correspondence carefully before submitting."},
		  {"id":11, "label":"How do I know if my Volkswagen has an EA189 engine?", "value":"To find out your car’s engine type, you’ll need your 17 digit Vehicle Identification Number (VIN). This is usually stamped on the lower corner of the windshield on the driver’s side and on the door frame of the driver’s side door.  Some vehicles may also have their VIN stamped on a metal plate under the hood, near the engine compartment.  Please enter the VIN into an online VIN decoder and it will tell you your engine model. If your car has an EA189 Engine, Pogust Goodhead will not be able to represent you further.  If you tick ‘not sure’ and we later establish you have an EA189, we will have to automatically terminate your client retainer."},
		  {"id":12, "label":"Can I claim in the Scottish NOx emissions cases?", "value":"We are no longer taking on new clients for the Scottish NOx emissions cases.  You may still be able to bring a claim in Scotland with another firm and we recommend you seek advice from a Scottish solicitor as soon as possible."}
		],
	  }

	useEffect(() => {
		initializeEmailButton();
	}, []);

	function openTalkdesk() {
		window.webchat.open();
	  }

	const [timeLeft, setTimeLeft] = useState(calculateTimeLeft("2025-01-08T00:00:00"));
	const [timeLeftCourt, setTimeLeftCourt] = useState(calculateTimeLeft("2025-01-24T00:00:00"));

	const settings = {
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 2000,
		dots: false,
		arrows: true
	};

	const settingsNews = {
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		dots: true,
		arrows: false
	};

	 useEffect(() => {
		  setData(questions);
		}, []);

	function calculateTimeLeft(dateString) {
		const targetDate = new Date(dateString); 
		const now = new Date();
		const difference = targetDate - now;

		if (difference <= 0) return null; // Return null if the date has passed

		const days = Math.floor(difference / (1000 * 60 * 60 * 24));
		const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
		const minutes = Math.floor((difference / (1000 * 60)) % 60);

		return { days, hours, minutes };
	}

	useEffect(() => {
		const timer = setInterval(() => {
		  setTimeLeft(calculateTimeLeft("2025-01-08T00:00:00"));
		  setTimeLeftCourt(calculateTimeLeft("2025-01-24T00:00:00"));
		}, 1000); // Update every second
	
		return () => clearInterval(timer); // Cleanup interval on component unmount
	  }, []);
	


	return (
	 <>
		<div className="blackBackground">
			<div className="pageWrapper ">
				<NavBar />
			</div>
		</div>

		<div className="flex-container">
			<div className="left-column">
				<div className="veryLargeText boldText">Mercedes Claim</div>
				<div className="largeText">Client Information Hub</div>
				<div className="smallText">England & Wales</div>
				<hr />
				<div className="mediumText">Sign-up Status:</div>
				<div className="mediumText greenText boldText">Closed</div>
				<hr />
				<div className="mediumText">Claims brought by Pogust Goodhead:</div>
				<div className="mediumText greenText boldText">130,000</div>
				<hr />
			</div>
			<div className="right-column width500">
				<Slider {...settings}>
					<div className="slideCard">
						<div className="mediumText">Case Status</div>
						<div className="slideNumberContainer mediumLargeText boldText blackBackground">1</div>
						<div className="mediumLargeText boldText">Claims filing</div>
						<div>We started legal action on behalf of our cliemts against Mercedes over alleged emissions cheating.</div>
						<img className="caseStatusImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Step-1-Complete.png" alt="Step1" />
					</div>
					<div className="slideCard med">
						<div className="mediumText">Case Status</div>
						<div className="slideNumberContainer mediumLargeText boldText">2</div>
						<div className="mediumLargeText boldText">Case ongoing</div>
						<div>We are working to Court-agreed litigation timetables as we pursue the case.</div>
						<img className="caseStatusImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Step-2.png" alt="Step2" />
					</div>
					<div className="slideCard">
						<div className="mediumText">Case Status</div>
						<div className="slideNumberContainer mediumLargeText boldText greyBackground">3</div>
						<div className="mediumLargeText boldText">Case results</div>
						<div>The case is ongoing and the final outcome of the claim has not yet been finalised.</div>
						<img className="caseStatusImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Step-3.png" alt="Step3" />
					</div>
				</Slider>
			</div>
		</div>

		<div className="title largeText boldText">
			Mercedes Deadlines
		</div>

		<div className="flex-container fifty-fifty whiteBackground">
			<div className="left-column">
				<hr />
				<div>Next Schedule of Information (SOI) Deadline:</div>
				<div className="boldText mediumText">8 January 2025</div>
				{timeLeft ? (
					<div>
					{`${timeLeft.days} Days ${timeLeft.hours} Hours ${timeLeft.minutes} Minutes`}
					</div>
				) : (
					<div className="boldText">The deadline has passed!</div>
				)}
				<div>Previous Dealine: 9 October 2024</div>
				<hr />
				<div>Next Court Service Date:</div>
				<div className="boldText mediumText">24 January 2025</div>
				{timeLeftCourt ? (
					<div>
					{`${timeLeftCourt.days} Days ${timeLeftCourt.hours} Hours ${timeLeftCourt.minutes} Minutes`}
					</div>
				) : (
					<div className="boldText">The deadline has passed!</div>
				)}
				<div>Previous Dealine: 25 October 2024</div>
			</div>
			<div className="right-column">
				<div className="gap20 mediumText">
					<div className="boldText">Important!</div>
					<div className="">Have you received an email from us regarding your <span className="boldText">Schedule of Information, or SOI?</span></div>
					<div className="">This is a form we need you to complete as soon as possible.</div>
					<div className="">Check your email now to see if you need to take action.</div>
				</div>
			</div>
		</div>

		<div className="wrapper lightGreyBackground">
			<div className="largeText boldText">Key Legal Updates</div>
			<div className="regularText">We’ve gathered all the key legal updates related to your claim in one place for easy reference. Other new key updates will be added here as well as emailed to you.</div>
			<div className="regularText">Our updates are confidential, intended solely for you and the claimants involved in the litigation, and they are not to be shared publicly.</div>
			<div className="legalUpdatesContainer mediumText boldText">
				<div className="legalUpdatesItem">
					<div>August 2024</div>
					<a className="button boldText" href="https://assets.pogustgoodhead.com/documents/mercedes/Aug24_MercedesAllClientUpdate_Email-updated.pdf" target="_blank" rel="noopener noreferrer">VIEW UPDATE</a>
				</div>
				<div className="legalUpdatesItem">
					<div>May 2024</div>
					<a className="button boldText" href="https://assets.pogustgoodhead.com/documents/mercedes/May24_MercedesAllClientUpdate_Email-updated.pdf" target="_blank" rel="noopener noreferrer">VIEW UPDATE</a>
				</div>
				<div className="legalUpdatesItem">
					<div>February 2024</div>
					<a className="button boldText" href="https://assets.pogustgoodhead.com/documents/mercedes/Feb24_MercedesClientUpdate_Email-updated.pdf" target="_blank" rel="noopener noreferrer">VIEW UPDATE</a>
				</div>
				<div className="legalUpdatesItem">
					<div>December 2023</div>
					<a className="button boldText" href="https://assets.pogustgoodhead.com/documents/mercedes/MercedesClientUpdateLetter_Dec23-Updated.pdf" target="_blank" rel="noopener noreferrer">VIEW UPDATE</a>
				</div>
				<div className="legalUpdatesItem">
					<div>June 2023</div>
					<a className="button boldText" href="https://assets.pogustgoodhead.com/documents/mercedes/Merc-Jun23-Update-updated.pdf" target="_blank" rel="noopener noreferrer">VIEW UPDATE</a>
				</div>
				<div className="legalUpdatesItem">
					<div>February 2023</div>
					<a className="button boldText" href="https://assets.pogustgoodhead.com/documents/mercedes/Merc-Feb23-Update-updated.pdf" target="_blank" rel="noopener noreferrer">VIEW UPDATE</a>
				</div>
			</div>
		</div>

		<div className="faqWrapper">
			<QuestionFormatFaq faqs={data.faqs} faqHeading={data.faqHeading} />
		</div>

		<div className="wrapper lightGreyBackground">
			<div>
				<img className="logo" src="https://mydieselclaim.com/wp-content/uploads/2025/01/pg-logo-black-rgb.png" alt="Pogust Goodhead Logo" />
			</div>
			<div>Pogust Goodhead is a leading global class action law firm. We are committed to supporting access to justice and holding multinationals to account.</div>
			<div>
				<a href="https://pogustgoodhead.com/" className="link boldText" target="_blank" rel="noopener noreferrer">Find out more about Pogust Goodhead</a>
			</div>
		</div>


		<div className="newsContainer specialContainer news-slick">
			<div className="largeText boldText">Mercedes News</div>
			<Slider {...settingsNews}>
				<div className="slideCard">
					<div className="flex-container fifty-fifty whiteBackground">
						<div className="left-column">
							<div className="newsItemsLeft">
								<div className="regularText">August 16, 2024</div>
								<div className="mediumLargeText boldText">Post Office Scandal and Emissions</div>
								<div className="regularText">What do the claimants in our emissions cases have in common with the sub-postmasters affected by the Horizon IT scandal involving the Post Office?  Well, more than you might initially think. While each individual’s experience is unique, there are legal..</div>
								<a className="buttonNews boldText" href="mdcreact/?post-office-scandal-and-emissions=true" target="_blank" rel="noopener noreferrer">Read more</a>
							</div>
						</div>
						<div className="right-column">
							<img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/newspress-collage-qvhuhtybr-1723742930384.webp" alt="Post Office Scandal and Emissions" />
						</div>
					</div>
				</div>
				<div className="slideCard">
					<div className="flex-container fifty-fifty whiteBackground">
						<div className="left-column">
							<div className="newsItemsLeft">
								<div className="regularText">August 6, 2024</div>
								<div className="mediumLargeText boldText">Latest ‘dieselgate’ case results in Mercedes going to the High Court</div>
								<div className="regularText">As part of an ongoing legal battle over Mercedes’ emissions scandal, hundreds of thousands of Mercedes drivers are taking the car manufacturer to the High Court on Thursday 9th February. The two-day hearing will be the first time Mercedes has...</div>
								<a className="buttonNews boldText"  href="https://www.lawnews.co.uk/sector-insights/litigation-adr/latest-dieselgate-case-results-in-mercedes-going-to-the-high-court/" target="_blank" rel="noopener noreferrer">Read more</a>
							</div>
						</div>
						<div className="right-column">
							<img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/pexels-mike-b-120049-1392x782-1.jpg" alt="mercedes headlights" />
						</div>
					</div>
				</div>
				<div className="slideCard">
					<div className="flex-container fifty-fifty whiteBackground">
						<div className="left-column">
						<div className="newsItemsLeft">
							<div className="regularText">August 16, 2024</div>
							<div className="mediumLargeText boldText">The Emissions Scandal - The Journey So Far</div>
							<div className="regularText">Where it all began… Our work to provide justice to the millions of people in the UK who were impacted by the Dieselgate emissions scandal started all the way back in 2015. Once Dieselgate broke, we began our landmark litigation...</div>
							<a className="buttonNews boldText" href="mdcreact/?the-emissions-scandal-the-journey-so-far=true" target="_blank" rel="noopener noreferrer">Read more</a>
						</div>
						</div>
						<div className="right-column">
							<img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/AdobeStock_314734079-1536x907-1.jpeg" alt="fuel pumps" />
						</div>
					</div>
				</div>
				<div className="slideCard">
					<div className="flex-container fifty-fifty whiteBackground">
						<div className="left-column">
							<div className="newsItemsLeft">
								<div className="regularText">August 6, 2024</div>
								<div className="mediumLargeText boldText">Claimant firms hail ‘turbo charge’ for dieselgate hearings</div>
								<div className="regularText">Claimants in the ’dieselgate’ group claim against motor manufacturers today hailed a judgment by the president of the King’s Bench Division setting an aggressive court timetable for the action. In Various claimants v Mercedes Benz Group & Ors Dame Victoria Sharp and three...</div>
								<a className="buttonNews boldText"  href="https://www.lawgazette.co.uk/law/claimant-firms-hail-turbo-charge-for-dieselgate-hearings/5118217.article" target="_blank" rel="noopener noreferrer">Read more</a>
							</div>
						</div>
						<div className="right-column">
							<img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/car-exhaust.webp" alt="car exhaust" />
						</div>
					</div>
				</div>
				<div className="slideCard">
					<div className="flex-container fifty-fifty whiteBackground">
						<div className="left-column">
							<div className="newsItemsLeft">
								<div className="regularText">June 14, 2024</div>
								<div className="mediumLargeText boldText">Emissions cheating case against car industry reveals legal bill to defend action</div>
								<div className="regularText">Lawyers defending unprecedented legal action against the car industry over emissions cheating have revealed in court the estimated costs of defending the claims are an eye-watering £320 million in legal fees. Claims on behalf of 1.5 million claimants are continuing...</div>
								<a className="buttonNews boldText"  href="https://pogustgoodhead.com/emissions-cheating-case-against-car-industry-reveals-legal-bill-to-defend-action/" target="_blank" rel="noopener noreferrer">Read more</a>
							</div>
						</div>
						<div className="right-column">
							<img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Insights-768-×-507px.jpg" alt="Traffic jam" />
						</div>
					</div>
				</div>
				<div className="slideCard">
					<div className="flex-container fifty-fifty whiteBackground">
						<div className="left-column">
							<div className="newsItemsLeft">
								<div className="regularText">May 2, 2024</div>
								<div className="mediumLargeText boldText">Group Litigation Orders granted against seven car manufacturers</div>
								<div className="regularText">Following the latest NOx Emissions Claim hearings, we are pleased to share that seven more Group Litigation Orders (GLOs) have been handed down by the Court. The Group Litigation Orders being granted means that each individual client case will be...</div>
								<a className="buttonNews boldText"  href="https://pogustgoodhead.com/group-litigation-orders-granted-against-seven-car-manufacturers/" target="_blank" rel="noopener noreferrer">Read more</a>
							</div>
						</div>
						<div className="right-column">
							<img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/diesel.png" alt="Diesel cars" />
						</div>
					</div>
				</div>
				<div className="slideCard">
					<div className="flex-container fifty-fifty whiteBackground">
						<div className="left-column">
							<div className="newsItemsLeft">
								<div className="regularText">February 6, 2024</div>
								<div className="mediumLargeText boldText">Ford to face trial alongside Mercedes for alleged emissions cheating</div>
								<div className="regularText">Ford will join Mercedes in the first set of car company cases to go to trial over alleged emissions cheating and a suite of manufacturers now face claims after an unprecedented month of action in the High Court. In a...</div>
								<a className="buttonNews boldText"  href="https://pogustgoodhead.com/ford-to-face-trial-alongside-mercedes-for-alleged-emissions-cheating/" target="_blank" rel="noopener noreferrer">Read more</a>
							</div>
						</div>
						<div className="right-column">
							<img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Insights-768-×-507px-56.jpg" alt="Exhaust" />
						</div>
					</div>
				</div>
				<div className="slideCard">
					<div className="flex-container fifty-fifty whiteBackground">
						<div className="left-column">
							<div className="newsItemsLeft">
								<div className="regularText">January 18, 2024</div>
								<div className="mediumLargeText boldText">BMW, Mercedes, and Vauxhall to face legal action in Scotland over emissions scandal</div>
								<div className="regularText">Thousands of motorists in Scotland have been given the go-ahead today in claims against three major car manufacturers. Over 45,000 claims were granted permission to proceed against BMW, Mercedes and Vauxhall over the emissions scandal. The cases are some of...</div>
								<a className="buttonNews boldText"  href="https://pogustgoodhead.com/bmw-mercedes-and-vauxhall-to-face-legal-action-in-scotland-over-emissions-scandal/" target="_blank" rel="noopener noreferrer">Read more</a>
							</div>
						</div>
						<div className="right-column">
							<img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Insights-768-×-507px-50.jpg" alt="bridge" />
						</div>
					</div>
				</div>
				<div className="slideCard">
					<div className="flex-container fifty-fifty whiteBackground">
						<div className="left-column">
							<div className="newsItemsLeft">
								<div className="regularText">January 8, 2024</div>
								<div className="mediumLargeText boldText">Important information for Mercedes owners</div>
								<div className="regularText">Have you registered for My Diesel Claim with a Mercedes vehicle? We need your help before 11 January 2024. We’re reaching an important milestone in the Mercedes emissions claim. We must have your information before 11 January so we can...</div>
								<a className="buttonNews boldText"  href="https://pogustgoodhead.com/important-information-for-mercedes-owners/" target="_blank" rel="noopener noreferrer">Read more</a>
							</div>
						</div>
						<div className="right-column">
							<img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Insights-768-×-507px-42.png" alt="Mercedes Badge" />
						</div>
					</div>
				</div>
				<div className="slideCard">
					<div className="flex-container fifty-fifty whiteBackground">
						<div className="left-column">
							<div className="newsItemsLeft">
								<div className="regularText">February 10, 2023</div>
								<div className="mediumLargeText boldText">Pogust Goodhead stands with Mercedes clients in court over dieselgate scandal</div>
								<div className="regularText">On Thursday 9 February 2023, Pogust Goodhead stood alongside hundreds of thousands of clients as they faced Mercedes, the billion-pound company, to court in the latest legal battle in the dieselgate scandal. Dieselgate remains one of the biggest corporate scandals...</div>
								<a className="buttonNews boldText"  href="https://pogustgoodhead.com/pogust-goodhead-stand-with-hundreds-of-thousands-of-mercedes-clients-in-court-over-dieselgate-scandal/" target="_blank" rel="noopener noreferrer">Read more</a>
							</div>
						</div>
						<div className="right-column">
							<img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/pexels-mike-b-104372-scaled-1-1536x864-1.jpg" alt="mercedes sign" />
						</div>
					</div>
				</div>
				<div className="slideCard">
					<div className="flex-container fifty-fifty whiteBackground">
						<div className="left-column">
							<div className="newsItemsLeft">
								<div className="regularText">July 19, 2021</div>
								<div className="mediumLargeText boldText">Dieselgate: The VZBZ File Lawsuit Against Mercedes Owners Daimler</div>
								<div className="regularText">Germany’s largest consumer protection group has filed a lawsuit against Daimler to help Mercedes owners get redress over the Dieselgate scandal. If successful, the lawsuit will set a precedent that would allow Mercedes GLC and GLK car owners to gain...</div>
								<a className="buttonNews boldText"  href="https://pogustgoodhead.com/dieselgate-the-vzbz-file-lawsuit-against-mercedes-owners-daimler/" target="_blank" rel="noopener noreferrer">Read more</a>
							</div>
						</div>
						<div className="right-column">
							<img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Untitled-design-4.png" alt="Pmercedes sign three" />
						</div>
					</div>
				</div>
				<div className="slideCard">
					<div className="flex-container fifty-fifty whiteBackground">
						<div className="left-column">
							<div className="newsItemsLeft">
								<div className="regularText">September 18, 2020</div>
								<div className="mediumLargeText boldText">UK Drivers One Step Closer To Receiving Mercedes Compensation</div>
								<div className="regularText">Mercedes-Benz has agreed to pay £1.7 billion to settle diesel emission cheat claims in the United States, meaning Mercedes UK drivers may be one step closer to getting the compensation they deserve. In a statement, Daimler AG, the parent company...</div>
								<a className="buttonNews boldText"  href="https://pogustgoodhead.com/uk-drivers-one-step-closer-to-receiving-mercedes-compensation/" target="_blank" rel="noopener noreferrer">Read more</a>
							</div>
						</div>
						<div className="right-column">
							<img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/38.jpg" alt="merc badge close up" />
						</div>
					</div>
				</div>
			</Slider>
		</div>
		

		<div className="peopleContainer">
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/TomGoodheadCol-600x600-1.webp" alt="Tom Goodhead" />
				<div className="mt10">
					<div className="boldText mediumText">Tom Goodhead</div>
					<div>Global Managing Partner | CEO</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/TonyWinterburnCol-600x600-1.webp" alt="Tony Winterburn" />
				<div className="mt10">
					<div className="boldText mediumText">Tony Winterburn</div>
					<div>Partner</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/PeterGallagherCol-1-600x600-1.webp" alt="Pete Gallagher" />
				<div className="mt10">
					<div className="boldText mediumText">Pete Gallagher</div>
					<div>Partner</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/AlisonWebbCol-600x600-1.webp" alt="Alison Webb" />
				<div className="mt10">
					<div className="boldText mediumText">Alison Webb</div>
					<div>Partner</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/MatthewNewbouldCol-1-600x600-1.webp" alt="Matthew Newbould" />
				<div className="mt10">
					<div className="boldText mediumText">Matthew Newbould</div>
					<div>Partner</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/MichaelBurkeCol-600x600-1.webp" alt="Michael Burke" />
				<div className="mt10">
					<div className="boldText mediumText">Michael Burke</div>
					<div>Partner</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/MeganLaffertyCol-600x600-1.webp" alt="Megan Lafferty" />
				<div className="mt10">
					<div className="boldText mediumText">Megan Lafferty</div>
					<div>Partner</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/PriyankaGladsonCol600.png" alt="Priyanka Gladson" />
				<div className="mt10">
					<div className="boldText mediumText">Priyanka Gladson</div>
					<div>Partner</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/MatthewHuntCol-600x600-1.webp" alt="Matthew Hunt" />
				<div className="mt10">
					<div className="boldText mediumText">Matthew Hunt</div>
					<div>Legal Director</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/OUR-TEAMS-12-600x600-1.webp" alt="Jade Weiner" />
				<div className="mt10">
					<div className="boldText mediumText">Jade Weiner</div>
					<div>Business Development Director</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Our-Team-template-800x800-3-600x600-1.webp" alt="Carolyn Ubben" />
				<div className="mt10">
					<div className="boldText mediumText">Carolyn Ubben</div>
					<div>Senior Associate Foreign Qualified (Australia)</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/MishaChandnaCol-600x600-1.webp" alt="Misha Chandna" />
				<div className="mt10">
					<div className="boldText mediumText">Misha Chandna</div>
					<div>Associate</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Nayomi-Goonesekere-2-600x600-1.webp" alt="Nayomi Goonesekere" />
				<div className="mt10">
					<div className="boldText mediumText">Nayomi Goonesekere</div>
					<div>Associate</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/OurTeamUpdate-600x600-1.webp" alt="Cristiane Melo Franco" />
				<div className="mt10">
					<div className="boldText mediumText">Cristiane Melo Franco</div>
					<div>Associate</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Ross-McKeown-June-24-600x600-1.webp" alt="Ross McKeown" />
				<div className="mt10">
					<div className="boldText mediumText">Ross McKeown</div>
					<div>Associate</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/BrunaOliveiraCol-600x600-1.webp" alt="Bruna Oliveria" />
				<div className="mt10">
					<div className="boldText mediumText">Bruna Oliveria</div>
					<div>Associate</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/HarnitaRaiCol-600x600-1.webp" alt="Harnita Rai" />
				<div className="mt10">
					<div className="boldText mediumText">Harnita Rai</div>
					<div>Associate</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/JaniceTangCol-600x600-1.webp" alt="Janice Tang" />
				<div className="mt10">
					<div className="boldText mediumText">Janice Tang</div>
					<div>Associate</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/JoshuaTarrantWindtCol-600x600-1.webp" alt="Joshua Tarrant-Windt" />
				<div className="mt10">
					<div className="boldText mediumText">Joshua Tarrant-Windt</div>
					<div>Associate</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Lorcan-treacy-transparent-600x600-1.webp" alt="Lorcan Treacy" />
				<div className="mt10">
					<div className="boldText mediumText">Lorcan Treacy</div>
					<div>Associate</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/AlexTyermanCol-600x600-1.webp" alt="Alex Tyerman" />
				<div className="mt10">
					<div className="boldText mediumText">Alex Tyerman</div>
					<div>Associate</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Tom-Firth-Jones-v2-600x600-1.webp" alt="Tom Firth-Jones" />
				<div className="mt10">
					<div className="boldText mediumText">Tom Firth-Jones</div>
					<div>Associate</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/HelinKaplankiranCol-600x600-1.webp" alt="Helin Kaplankiran" />
				<div className="mt10">
					<div className="boldText mediumText">Helin Kaplankiran</div>
					<div>Trainee Solicitor</div>
				</div>
			</div>
			<div className="peopleItem">
				<img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/AyeshaKhanCol-600x600-1.webp" alt="Ayesha Khan" />
				<div className="mt10">
					<div className="boldText mediumText">Ayesha Khan</div>
					<div>Trainee Solicitor</div>
				</div>
			</div>
		</div>

		<div className="wrapper lightGreyBackground">
				<div className="largeText boldText">Contact Us</div>
				<div>If you can’t find what you’re looking for on this page and need further help with your claim, you can speak to our dedicated emissions care team.</div>
				<div className="buttonContact boldText" onClick={openTalkdesk}>Speak to our team using Live Chat</div>
				<a href="tel:03330155900" className="buttonContact boldText">Phone: 0333 015 5900</a>
				<div>We want to make sure the process is as simple as possible for you. We’re here to help every step of the way.</div>
		</div>

		<div className="specialContainer">
          <TrustPilot />
        </div>
		
		<div>
			<Footer />
		</div>

	 </>
	);
  }

export default MercClientHub;